import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractDynamicInput } from '../abstract-dynamic-input';

@Component({
    selector: 'odq-dynamic-input',
    templateUrl: './dynamic-input.component.html',
    styleUrls: ['./dynamic-input.component.scss'],
    standalone: false
})
export class DynamicInputComponent extends AbstractDynamicInput {

  constructor(translate: TranslateService) { super(translate) }

}
